export default "__VITE_ASSET__Cabyto7K__"